import { inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs';

import { UnsavedDialogsService } from './unsaved-dialogs.service';

/**
 * Replaces Material's `closeOnNavigation` (off in main.ts): on browser back/forward, closes all
 * dialogs except protected form dialogs before leave-page guards run, so their prompts never stack.
 */
export function closeDialogsOnHistoryNavigation(): void {
  const dialog = inject(MatDialog);
  const unsavedDialogs = inject(UnsavedDialogsService);

  inject(Router)
    .events.pipe(filter((event) => event instanceof NavigationStart && event.navigationTrigger === 'popstate'))
    .subscribe(() => {
      dialog.openDialogs.filter((ref) => !unsavedDialogs.isRegistered(ref)).forEach((ref) => ref.close());
    });
}
